/* ==========================================================================
   Lumen — section-newsletter-popup.js
   Opens the newsletter <lumen-modal> after a merchant-set delay, capped by
   a localStorage timestamp ("lumen:newsletter-popup") so it appears at most
   once per N days. It stands down when:
   - the exit-intent popup has already opened this session (that section
     marks sessionStorage keys prefixed "lumen:exit-intent" — see
     sections/exit-intent.liquid, data-storage-key="lumen:exit-intent:<id>")
   - another dialog is already open when the timer fires (cart drawer,
     search, exit intent…), so popups never stack.
   After a signup round-trip the section renders [data-newsletter-popup-open]
   and the modal re-opens to show the success or error message. In the theme
   editor the section renders statically instead (no modal — see the .liquid),
   so this file is a no-op there.
   ========================================================================== */
(function () {
  'use strict';

  var EXIT_INTENT_PREFIX = 'lumen:exit-intent';
  var DAY_MS = 86400000;

  function openHost(host) {
    if (typeof host.open === 'function') {
      host.open();
    } else if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('lumen-modal').then(function () {
        if (typeof host.open === 'function') host.open();
      });
    }
  }

  function exitIntentOpenedThisSession() {
    try {
      for (var i = 0; i < window.sessionStorage.length; i++) {
        var k = window.sessionStorage.key(i);
        if (k && k.indexOf(EXIT_INTENT_PREFIX) === 0) return true;
      }
    } catch (e) { /* private mode */ }
    return false;
  }

  function lastShownAt(key) {
    try {
      var v = parseInt(window.localStorage.getItem(key), 10);
      return isNaN(v) ? 0 : v;
    } catch (e) { return 0; }
  }

  function markShown(key) {
    try { window.localStorage.setItem(key, String(Date.now())); } catch (e) { /* private mode */ }
  }

  function setup(host) {
    if (host.getAttribute('data-np-done') === 'true') return;
    host.setAttribute('data-np-done', 'true');

    var key = host.getAttribute('data-storage-key') || 'lumen:newsletter-popup';

    /* Route Escape through host.close() so body scroll always unlocks. */
    var dialog = host.querySelector('dialog');
    if (dialog) {
      dialog.addEventListener('cancel', function (e) {
        e.preventDefault();
        if (typeof host.close === 'function') host.close();
      });
    }

    /* Signup round-trip: re-open to show success/errors, refresh the cap. */
    if (host.querySelector('[data-newsletter-popup-open]')) {
      markShown(key);
      openHost(host);
      return;
    }

    /* Frequency cap. */
    var days = parseInt(host.getAttribute('data-frequency-days'), 10);
    if (isNaN(days) || days < 1) days = 7;
    var last = lastShownAt(key);
    if (last && Date.now() - last < days * DAY_MS) return;

    var delay = parseInt(host.getAttribute('data-delay'), 10);
    if (isNaN(delay) || delay < 0) delay = 6;

    window.setTimeout(function () {
      if (exitIntentOpenedThisSession()) return;
      if (document.querySelector('dialog[open]')) return; /* never stack popups */
      markShown(key);
      openHost(host);
    }, delay * 1000);
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-newsletter-popup]');
    Array.prototype.forEach.call(nodes, setup);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
